import React from "react";
import { Navigate } from "react-router-dom";
import {
  useHasPermission,
  useHasAnyPermission,
} from "../../../../common/permissions";

interface AffiliateRouteGuardProps {
  children: React.ReactElement;
  routeType:
    | "dashboard"
    | "providers-and-group"
    | "maps"
    | "charge-categories"
    | "settings";
}

const AffiliateRouteGuard: React.FC<AffiliateRouteGuardProps> = ({
  children,
  routeType,
}) => {
  // Check permissions based on route type
  // Check permissions based on route type
  const hasDashboardPermission = useHasPermission(
    "Admin Affiliate Dashboard",
    "viewAll",
  );
  const hasProvidersAndGroupPermission = useHasAnyPermission(
    [
      "Admin Affiliate Providers and groups",
      "Admin Affiliate Linked Providers and Locations Provider",
      "Admin Affiliate Linked Providers and Locations Locations",
    ],
    "viewAll",
  );
  const hasMapsPermission = useHasPermission("Admin Affiliate Maps", "viewAll");
  const hasChargeCategoriesPermission = useHasPermission(
    "Admin Affiliate Charge Categories",
    "viewAll",
  );
  const hasSettingsPermission = useHasPermission(
    "Admin Affiliate Settings",
    "viewAll",
  );

  // Determine if user has access to this route
  let hasAccess = false;

  switch (routeType) {
    case "dashboard":
      hasAccess = hasDashboardPermission;
      break;
    case "providers-and-group":
      hasAccess = hasProvidersAndGroupPermission;
      break;
    case "maps":
      hasAccess = hasMapsPermission;
      break;
    case "charge-categories":
      hasAccess = hasChargeCategoriesPermission;
      break;
    case "settings":
      hasAccess = hasSettingsPermission;
      break;
    default:
      hasAccess = false;
  }

  if (!hasAccess) {
    // Find the first accessible tab and redirect there based on a priority
    if (hasDashboardPermission) {
      return <Navigate to="/admin/affiliate/dashboard" replace />;
    } else if (hasProvidersAndGroupPermission) {
      return <Navigate to="/admin/affiliate/providers-and-group" replace />;
    } else if (hasMapsPermission) {
      return <Navigate to="/admin/affiliate/maps" replace />;
    } else if (hasChargeCategoriesPermission) {
      return <Navigate to="/admin/affiliate/charge-categories" replace />;
    } else if (hasSettingsPermission) {
      return <Navigate to="/admin/affiliate/settings" replace />;
    } else {
      // If no affiliate permissions, redirect to admin dashboard
      return <Navigate to="/admin/dashboard" replace />;
    }
  }

  return children;
};

export default AffiliateRouteGuard;
